import { Component } from '@angular/core';
import { DialogBaseViewComponent, SimpleDialogData } from '@sb/library/base';

@Component({
    selector: 'lib-dialog-confirm',
    templateUrl: './dialog-confirm.component.html',
    styleUrls: ['./dialog-confirm.component.scss'],
})
export class DialogConfirmComponent extends DialogBaseViewComponent<SimpleDialogData> {
    get primaryButtonText(): string {
        return this.data.PrimaryButtonText ?? $localize`:@@CommonOKButton:OK`;
    }

    get secondaryButtonText(): string {
        return this.data.SecondaryButtonText ?? $localize`:@@CommonCancelButton:Cancel`;
    }
}
